

import { Component, Mixins } from "vue-property-decorator";
import GlobalMixin from "@/mixins/global";
import { IPaymentCard } from "@/components/IBPayment/interface";
import IBPaymentCardProps from "@/components/IBPayment/mixins/IBPaymentCardProps";
import IBFileDownload from "@/components/IBFile/IBFileDownload.vue";
import IBStatusAlert from "@/components/IBPayment/IBStatusAlert.vue";
import IBAlertAmount from "@/components/IBAlert/IBAlertAmount/IBAlertAmount.vue";
import IBPaymentCardActions from "@/components/IBPayment/IBPaymentCardActions.vue";
import IBPaymentCardList from "@/components/IBPayment/IBPaymentCardList.vue";
import IBSpinnerLoading from '@/components/IBLoading/IBSpinnerLoading.vue';
import IBPaymentRejected from "@/components/IBPayment/IBPaymentRejected.vue";

@Component({
	components: {
		IBAlertAmount,
		IBStatusAlert,
		IBPaymentCardActions,
		IBPaymentCardList,
		IBFileDownload,
		IBSpinnerLoading,
		IBPaymentRejected
	}
})
export default class IBPaymentCardContent extends Mixins(
	GlobalMixin,
	IBPaymentCardProps
) implements IPaymentCard {

	private errorPaymentState: number[] = [6, -9, -14, 7, 14, 0]; // статус [6, -9] = Удален, статус [-14] = Не отправлен, статус [7, 14] = Забракован, статус [0] = Не определен.

	get hasActions(): boolean {
		return !!(this.actions &&
			((this.actions.left && this.actions.left.length) ||
				(this.actions.right && this.actions.right.length)));
	}

	get hasFiles(): boolean {
		return !!this.content?.files?.length;
	}

}

